<template>
  <div v-if="isVisible" class="deviceList">
    <router-link to="/lotus1device">
      <!-- <div class="lotus1" @click="$emit('change-style')"> -->
      <div class="lotus1">
        <img
          src="https://static4.coolbrainscience.cn/5b703328a6984b80a8e585820a90c7cf.png"
          alt=""
        />
        <div class="lotus1_txt">
          <p class="t1">LOTUS 1</p>
          <p class="t2">经典版</p>
        </div>
      </div>
    </router-link>
    <router-link to="/lotus2device">
      <div class="lotus2">
        <img
          src="https://static4.coolbrainscience.cn/a9ba8d3badfe4033839be37599d26c66.png"
          alt=""
        />
        <div class="lotus2_txt">
          <p class="t1">LOTUS 2</p>
          <p class="t2">能量版</p>
        </div>
      </div>
    </router-link>
    <router-link to="/lotus2Rdevice">
      <div class="lotus2R">
        <img
          src="https://static4.coolbrainscience.cn/00c0b3845d854046a791464c2c4a19ac.png"
          alt=""
        />
        <div class="lotus2R_txt">
          <p class="t1">LOTUS 2R</p>
          <p class="t2">认知版</p>
        </div>
      </div>
    </router-link>
  </div>
</template>
<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style scoped>
.deviceList {
  width: 100vw;
  background: white;
  display: flex;
  justify-content: center;
  padding: 1.46vw 0;
  text-align: center;
}

.deviceList img {
  width: 9.37vw;
  height: 6.67vw;
}

.t1 {
  color: #333333;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 0.9375vw;
}

.t2 {
  color: #333333;
  font-weight: 300;
  font-family: "SourceHanSansCN-Light";
  font-size: 0.9375vw;
}

.lotus2 {
  margin: 0 8.3vw;
}
</style>



// WEBPACK FOOTER //
// src/components/common/DeviceList.vue